import { Alert, AlertColor, Grow, Slide, Snackbar, SnackbarOrigin } from '@mui/material';
import { ReactNode, useState } from 'react';

export type SimpleAlertOption = SnackbarOrigin & {
    open: boolean;
    autoHideDuration?: number | null;
    severity: AlertColor;
    message: string;
    onClose?: () => void;
};

export const useSimpleAlert = () => {
    const [simpleAlertOption, setSimpleAlertOption] = useState<SimpleAlertOption>({
        vertical: 'top',
        horizontal: 'center',
        autoHideDuration: undefined,
        severity: 'success',
        message: '',
        open: false,
        onClose: undefined,
    });
    const show = (props: Partial<SnackbarOrigin> & Pick<SimpleAlertOption, 'autoHideDuration' | 'severity' | 'message'>) =>
        setSimpleAlertOption({ ...simpleAlertOption, ...props, open: true });
    return { simpleAlertOption, setSimpleAlertOption, show };
};

export type SimpleAlertProps = ReturnType<typeof useSimpleAlert>;

export const SimpleAlert = (props: SimpleAlertProps): React.ReactElement => {
    const { simpleAlertOption, setSimpleAlertOption, show } = props;
    const { vertical, horizontal, autoHideDuration, severity, message, open, onClose } = simpleAlertOption;
    return (
        <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={typeof onClose == 'function' ? onClose : () => setSimpleAlertOption({ ...simpleAlertOption, open: false })}
            key={vertical + horizontal}
            autoHideDuration={autoHideDuration}
        >
            <Alert
                severity={severity}
                variant='filled'
                onClose={typeof onClose == 'function' ? onClose : () => setSimpleAlertOption({ ...simpleAlertOption, open: false })}
            >
                {message}
            </Alert>
        </Snackbar>
    );
};
